import { DXTRADE_POSITION_EFFECT } from './constants'

export const isOpenPositionEffect = (positionEffect?: string | null): boolean =>
  positionEffect === DXTRADE_POSITION_EFFECT.OPEN

export const isClosePositionEffect = (positionEffect?: string | null): boolean =>
  positionEffect === DXTRADE_POSITION_EFFECT.CLOSE
